"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FCI_IDENTITY = exports.FCI_HEADER = exports.FCI_ENDPOINT = void 0;
const FCI_HEADER = exports.FCI_HEADER = {
  ErrorType: "X-FCI-ErrorType",
  ErrorInfo: "X-FCI-ErrorInfo",
  Feature: "X-FCI-Feature"
};
const FCI_ENDPOINT = exports.FCI_ENDPOINT = "/fel/webapi/v2/avro/FCI";
const FCI_IDENTITY = exports.FCI_IDENTITY = {
  GroupName: "searchui",
  ServiceName: "searchforms",
  StackId: "searchui-searchforms",
  Feature: "SearchForms"
};